// lib/waDeliveryTruth.js — جولة إصلاح 2026-10-08 (البند 1)
// يسأل GET /wa-delivery-status/{wamid} بشكل متكرر حتى تصل حقيقة التسليم
// (delivered/read/failed) أو ينتهي الوقت. يُستخدم بعد أي إرسال اختباري
// بدل افتراض «نجاح» لحظة قبول Meta للطلب فقط. لا إرسال هنا.
import { api } from "./api";

export async function pollDeliveryTruth(wamid, { intervalMs = 4000, maxTries = 6, onUpdate } = {}) {
  if (!wamid) {
    return { status: "accepted_pending", status_ar: "⏳ قُبلت لدى Meta — بانتظار التسليم" };
  }
  for (let i = 0; i < maxTries; i++) {
    try {
      const { data } = await api.get(`/wa-delivery-status/${encodeURIComponent(wamid)}`);
      if (onUpdate) onUpdate(data);
      if (data.status === "delivered" || data.status === "read" || data.status === "failed") {
        return data;
      }
    } catch {
      // keep polling — لا نعتبر فشل الشبكة فشل تسليم
    }
    await new Promise((res) => setTimeout(res, intervalMs));
  }
  return { status: "unknown_timeout",
            status_ar: "⏳ لم يتأكد التسليم بعد — راجعي «سجل الرقم» لاحقاً" };
}

// نص عربي موحَّد لأي نتيجة إرسال اختباري — لا نص «بنجاح» يُعرض قبل هذه الدالة.
export function deliveryTruthLabel(data) {
  if (!data) return "⏳ قُبلت لدى Meta — بانتظار التسليم";
  if (data.status === "failed" && data.fail) {
    const f = data.fail;
    return `❌ فشلت: ${f.title_ar || "غير معروف"}${f.code ? ` (رمز Meta ${f.code})` : ""}`;
  }
  return data.status_ar || data.status;
}
